import { useEffect, useState } from "react";

const USER = "lawnworksnwa";
const DOMAIN = "gmail.com";

interface ObfuscatedEmailProps {
  className?: string;
}

/**
 * Renders the business email without ever placing the raw address in the
 * static HTML — scrapers see the "at / dot" form, real visitors see and can
 * click the normal address once the page is interactive.
 */
export const useEmailAddress = () => {
  const [address, setAddress] = useState<string | null>(null);
  useEffect(() => {
    setAddress(`${USER}@${DOMAIN}`);
  }, []);
  return address;
};

export const emailMailto = (address: string | null) =>
  address ? `mailto:${address}` : "/contact";

const ObfuscatedEmail = ({ className }: ObfuscatedEmailProps) => {
  const address = useEmailAddress();
  return (
    <span className={className}>
      {address ?? `${USER} at ${DOMAIN.replace(".", " dot ")}`}
    </span>
  );
};

export default ObfuscatedEmail;
